const aiData = [
    {
        id: 1,
        name: "人脸服务",
        data: [
            {
                img_url: "https://lanying-official-website.oss-cn-beijing.aliyuncs.com/ai/same.png",
                img_alt: "人脸比对",
                img_title: "人脸比对",
                img_desc: "人脸比对，让两个人脸照片进行比对判断是否是同一个人"
            },
            {
                img_url: "https://lanying-official-website.oss-cn-beijing.aliyuncs.com/ai/count.png",
                img_alt: "人脸计数",
                img_title: "人脸计数",
                img_desc: "计算人脸个数，从一张图片里找到所有人脸，这样可以统计图片人数"
            },
            {
                img_url: "https://lanying-official-website.oss-cn-beijing.aliyuncs.com/ai/emotion.png",
                img_alt: "情感分析",
                img_title: "情感分析",
                img_desc: "情绪预测，通过表情模型来检测图片中人物的心情状态，做出正确判断"
            },
            {
                img_url: "https://lanying-official-website.oss-cn-beijing.aliyuncs.com/ai/living.png",
                img_alt: "活体检测",
                img_title: "活体检测",
                img_desc: "活体检测，判断当前扫描行为是否是通用图片或视频在欺骗程序"
            },
            {
                img_url: "https://lanying-official-website.oss-cn-beijing.aliyuncs.com/ai/living.png",
                img_alt: "活体检测",
                img_title: "活体检测",
                img_desc: "活体检测，判断当前扫描行为是否是通用图片或视频在欺骗程序"
            }
        ]
    },
    {
        id: 2,
        name: "图像推理",
        data: [
            {
                img_url: "https://os.alipayobjects.com/rmsportal/QBnOOoLaAfKPirc.png",
                img_alt: "111",
                img_title: "Europe Street beat",
                img_desc: "www.instagram.com"
            },
            {
                img_url: "https://os.alipayobjects.com/rmsportal/QBnOOoLaAfKPirc.png",
                img_alt: "222",
                img_title: "Europe Street beat",
                img_desc: "www.instagram.com"
            }
        ]
    },
    {
        id: 3,
        name: "语音合成",
        data: [
            {
                img_url: "https://os.alipayobjects.com/rmsportal/QBnOOoLaAfKPirc.png",
                img_alt: "111",
                img_title: "Europe Street beat",
                img_desc: "www.instagram.com"
            }
        ]
    },
    {
        id: 4,
        name: "文字提取",
        data: [
            {
                img_url: "https://os.alipayobjects.com/rmsportal/QBnOOoLaAfKPirc.png",
                img_alt: "111",
                img_title: "Europe Street beat",
                img_desc: "www.instagram.com"
            },
            {
                img_url: "https://os.alipayobjects.com/rmsportal/QBnOOoLaAfKPirc.png",
                img_alt: "222",
                img_title: "Europe Street beat",
                img_desc: "www.instagram.com"
            }
        ]
    },
];

export default aiData;
